import React from 'react';
import PropTypes from 'prop-types';

export const NearbyCitiesRoutesRecommend = ({ item, idx }) => (
  <li key={`city_${idx}`} className="appendBottom10">
    {item}
  </li>
);

NearbyCitiesRoutesRecommend.propTypes = {
  item: PropTypes.string,
  idx: PropTypes.number
};

export default NearbyCitiesRoutesRecommend;
